import { UseFormRegister, UseFormRegisterReturn, FieldValues } from 'react-hook-form'
import { Textarea } from "@/components/ui/textarea"
import { Label } from "@/components/ui/label"

interface TextAreaFloatingProps {
    label: string;
    errorClasses?: string;
    formClasses?: string;
    labelClasses?: string;
    controlId?: string;
    errorMessage?: string | undefined;
    showError?: boolean;
    register: UseFormRegister<FieldValues> | UseFormRegisterReturn<string>;
    placeholder?: string;
    disabled?: boolean;
    id?: string;
    [key: string]: any;
}

const TextAreaFloating: React.FC<TextAreaFloatingProps> = ({
    label,
    errorClasses="custom_error pt-1",
    errorMessage,
    showError=false,
    register,
    disabled=false,
    id="",
    ...rest
}) => {
    return (
        <div className="flex flex-col w-full">
            <Label className="mb-2" htmlFor={id}>{label}</Label>
            <Textarea id={id} {...register} disabled={disabled} {...rest} rows={4}/>
            { showError && (
                <p className={errorClasses}>
                    {errorMessage}
                </p>
            )}
        </div>
    )
}

export default TextAreaFloating;
